import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CorporateFormFields } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { useCorporateFormContext } from 'src/components/enterprise/features/Corporate/components/Form/CorporateFormProvider/useCorporateFormContext';
import {
  getAutofilledFormValues,
  isFieldEmpty,
} from 'src/components/enterprise/features/Corporate/components/Form/utils/autofillForm.utils';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { FeatureFlag } from 'src/types/FeatureFlag';

export interface UseCorpFormAutofillReturn {
  handleAutofillForm: () => Promise<void>;
  shouldShowAutofillButton: boolean;
}

export const useCorpFormAutofill = (): UseCorpFormAutofillReturn => {
  const { setValue, trigger, getValues } =
    useFormContext<CorporateFormFields>();
  const { isEditPage } = useCorporateFormContext();

  const handleAutofillForm = useCallback(async (): Promise<void> => {
    const autofilledValues = getAutofilledFormValues();
    const currentValues = getValues();

    Object.entries(autofilledValues).forEach(([key, value]) => {
      const fieldKey = key as keyof CorporateFormFields;
      const currentValue = currentValues[fieldKey];

      if (isFieldEmpty(currentValue)) {
        setValue(fieldKey, value);
      }
    });

    await trigger();
  }, [getValues, setValue, trigger]);

  const shouldShowAutofillButton =
    !isEditPage && useFeatureFlag(FeatureFlag.ENABLE_AUTOFILL_CORP).value;

  return {
    handleAutofillForm,
    shouldShowAutofillButton,
  };
};
